import {
  ADD_DESCRIPTION_MASTER,
  ADD_ENDS_MASTER,
  ADD_INSPECTION_LOC_MASTER,
  ADD_MANUFACTURER_MASTER,
  ADD_SIZE_MASTER,
  ADD_SURFACE_MASTER,
  ADD_TYPE_MASTER,
  ADD_WELDER_MASTER,
  MASTER_DESCRIPTION,
  MASTER_ENDS,
  MASTER_INSPECTION_LOC,
  MASTER_MANUFACTURER,
  MASTER_SIZE,
  MASTER_SURFACE,
  MASTER_TYPE,
  MASTER_WELDER,
} from "../../../components/common/api";
import { axiosInstance } from "../../../components/common/interceptor";
import {
  fetchDescriptionFailure,
  fetchDescriptionStart,
  fetchDescriptionSuccess,
  fetchEndsStart,
  fetchEndsSuccess,
  fetchEndsFailure,
  fetchInspectionLocStart,
  fetchInspectionLocSuccess,
  fetchInspectionLocFailure,
  fetchManufacturerStart,
  fetchManufacturerSuccess,
  fetchManufacturerFailure,
  fetchSizeStart,
  fetchSizeSuccess,
  fetchSizeFailure,
  fetchSurfaceStart,
  fetchSurfaceSuccess,
  fetchSurfaceFailure,
  fetchTypeStart,
  fetchTypeSuccess,
  fetchTypeFailure,
  addDescriptionStart,
  addDescriptionSuccess,
  addDescriptionFailure,
  fetchWelderStart,
  fetchWelderSuccess,
  fetchWelderFailure,
  addEndsStart,
  addEndsSuccess,
  addEndsFailure,
  addInspectionLocStart,
  addInspectionLocSuccess,
  addInspectionLocFailure,
  addManufacturerStart,
  addManufacturerSuccess,
  addManufacturerFailure,
  addSizeStart,
  addSizeSuccess,
  addSizeFailure,
  addSurfaceStart,
  addSurfaceSuccess,
  addSurfaceFailure,
  addTypeStart,
  addTypeSuccess,
  addTypeFailure,
  addWelderStart,
  addWelderSuccess,
  addWelderFailure,
  deleteDescriptionStart,
  deleteDescriptionSuccess,
  deleteDescriptionFailure,
  deleteEndsStart,
  deleteEndsSuccess,
  deleteEndsFailure,
  deleteInspectionLocStart,
  deleteInspectionLocSuccess,
  deleteInspectionLocFailure,
  deleteManufacturerStart,
  deleteManufacturerSuccess,
  deleteManufacturerFailure,
  deleteSizeStart,
  deleteSizeSuccess,
  deleteSizeFailure,
  deleteSurfaceStart,
  deleteSurfaceSuccess,
  deleteSurfaceFailure,
  deleteTypeStart,
  deleteTypeSuccess,
  deleteTypeFailure,
  deleteWelderStart,
  deleteWelderSuccess,
  deleteWelderFailure,
  editDescriptionStart,
  editDescriptionSuccess,
  editDescriptionFailure,
} from "../../reducer/MasterReducer/MasterReducer";

let isGetDescriptionMaster = false;
let isGetEndsMaster = false;
let isGetInspectionLocMaster = false;
let isGetManufacturerMaster = false;
let isGetSizeMaster = false;
let isGetSurfaceMaster = false;
let isGetTypeMaster = false;
let isGetWeldingMaster = false;

// ............. Get Description Master Details.................

export const GetDescriptionMaster = () => async (dispatch) => {
  if (isGetDescriptionMaster) return;
  isGetDescriptionMaster = true;
  dispatch(fetchDescriptionStart());
  try {
    const response = await axiosInstance.get(`${MASTER_DESCRIPTION}`);

    if (response.status !== 200) {
      throw new Error("Failed to fetch inspector details.");
    }
    console.log("response datya", response?.data?.result);
    dispatch(fetchDescriptionSuccess(response?.data?.result));
  } catch (error) {
    console.error("Error fetching details:", error);
    dispatch(fetchDescriptionFailure(error.message));
  } finally {
    isGetDescriptionMaster = false;
  }
};

// .............. Get Ends Master....................

export const GetEndsMaster = () => async (dispatch) => {
  if (isGetEndsMaster) return;
  isGetEndsMaster = true;
  dispatch(fetchEndsStart());
  try {
    const response = await axiosInstance.get(`${MASTER_ENDS}`);
    if (response.status !== 200) {
      throw new Error("Failed to fetch inspector details.");
    }
    // console.log("response datya", response?.data?.result);
    dispatch(fetchEndsSuccess(response?.data?.result));
  } catch (error) {
    console.error("Error fetching details:", error);
    dispatch(fetchEndsFailure(error.message));
  } finally {
    isGetEndsMaster = false;
  }
};

// ................ Get Inspection Loc Master ..........................

export const GetInspectionLocMaster = () => async (dispatch) => {
  if (isGetInspectionLocMaster) return;
  isGetInspectionLocMaster = true;
  dispatch(fetchInspectionLocStart());
  try {
    const response = await axiosInstance.get(`${MASTER_INSPECTION_LOC}`);
    if (response.status !== 200) {
      throw new Error("Failed to fetch inspector details.");
    }
    console.log("response datya", response?.data?.result);
    dispatch(fetchInspectionLocSuccess(response?.data?.result));
  } catch (error) {
    console.error("Error fetching details:", error);
    dispatch(fetchInspectionLocFailure(error.message));
  } finally {
    isGetInspectionLocMaster = false;
  }
};

// ....................... Get Manufacturer Master .........................

export const GetManufacturerMaster = () => async (dispatch) => {
  if (isGetManufacturerMaster) return;
  isGetManufacturerMaster = true;
  dispatch(fetchManufacturerStart());
  try {
    const response = await axiosInstance.get(`${MASTER_MANUFACTURER}`);
    if (response.status !== 200) {
      throw new Error("Failed to fetch inspector details.");
    }
    console.log("response datya", response?.data?.result);
    dispatch(fetchManufacturerSuccess(response?.data?.result));
  } catch (error) {
    console.error("Error fetching details:", error);
    dispatch(fetchManufacturerFailure(error.message));
  } finally {
    isGetManufacturerMaster = false;
  }
};

// .................... Get Size Master ...........................

export const GetSizeMaster = () => async (dispatch) => {
  if (isGetSizeMaster) return;
  isGetSizeMaster = true;
  dispatch(fetchSizeStart());
  try {
    const response = await axiosInstance.get(`${MASTER_SIZE}`);
    if (response.status !== 200) {
      throw new Error("Failed to fetch inspector details.");
    }
    console.log("response datya", response?.data?.result);
    dispatch(fetchSizeSuccess(response?.data?.result));
  } catch (error) {
    console.error("Error fetching details:", error);
    dispatch(fetchSizeFailure(error.message));
  } finally {
    isGetSizeMaster = false;
  }
};

// ....................... Get Surface  Master ....................

export const GetSurfaceMaster = () => async (dispatch) => {
  if (isGetSurfaceMaster) return;
  isGetSurfaceMaster = true;
  dispatch(fetchSurfaceStart());
  try {
    const response = await axiosInstance.get(`${MASTER_SURFACE}`);
    if (response.status !== 200) {
      throw new Error("Failed to fetch inspector details.");
    }
    console.log("response datya", response?.data?.result);
    dispatch(fetchSurfaceSuccess(response?.data?.result));
  } catch (error) {
    console.error("Error fetching details:", error);
    dispatch(fetchSurfaceFailure(error.message));
  } finally {
    isGetSurfaceMaster = false;
  }
};

// ...................... Get Type Master .........................

export const GetTypeMaster = () => async (dispatch) => {
  if (isGetTypeMaster) return;
  isGetTypeMaster = true;
  dispatch(fetchTypeStart());
  try {
    const response = await axiosInstance.get(`${MASTER_TYPE}`);
    if (response.status !== 200) {
      throw new Error("Failed to fetch inspector details.");
    }
    console.log("response datya", response?.data?.result);
    dispatch(fetchTypeSuccess(response?.data?.result));
  } catch (error) {
    console.error("Error fetching details:", error);
    dispatch(fetchTypeFailure(error.message));
  } finally {
    isGetTypeMaster = false;
  }
};

// ..................... Get Welding Master ..................

export const GetWeldingMaster = () => async (dispatch) => {
  if (isGetWeldingMaster) return;
  isGetWeldingMaster = true;
  dispatch(fetchWelderStart());
  try {
    const response = await axiosInstance.get(`${MASTER_WELDER}`);
    if (response.status !== 200) {
      throw new Error("Failed to fetch inspector details.");
    }
    console.log("response datya", response?.data?.result);
    dispatch(fetchWelderSuccess(response?.data?.result));
  } catch (error) {
    console.error("Error fetching details:", error);
    dispatch(fetchWelderFailure(error.message));
  } finally {
    isGetWeldingMaster = false;
  }
};

// .................. Add Description Master .................

export const addDescriptionMaster = (descriptionData) => async (dispatch) => {
  dispatch(addDescriptionStart());
  try {
    const response = await axiosInstance.post(`${ADD_DESCRIPTION_MASTER}`, {
      name: descriptionData.name,
    });
    dispatch(addDescriptionSuccess(response.data));
    return response.data;
  } catch (error) {
    dispatch(
      addDescriptionFailure(
        error.response ? error.response.data : "An error occurred"
      )
    );
    throw error;
  }
};

// .................. Add Ends Master .................

export const addEndsMaster = (descriptionData) => async (dispatch) => {
  dispatch(addEndsStart());
  try {
    const response = await axiosInstance.post(`${ADD_ENDS_MASTER}`, {
      name: descriptionData.name,
    });
    dispatch(addEndsSuccess(response.data));
    return response.data;
  } catch (error) {
    dispatch(
      addEndsFailure(error.response ? error.response.data : "An error occurred")
    );
    throw error;
  }
};

// .................. Add Inspection Loc Master .................

export const addInspectionLocMaster = (descriptionData) => async (dispatch) => {
  dispatch(addInspectionLocStart());
  try {
    const response = await axiosInstance.post(`${ADD_INSPECTION_LOC_MASTER}`, {
      name: descriptionData.name,
    });
    dispatch(addInspectionLocSuccess(response.data));
    return response.data;
  } catch (error) {
    dispatch(
      addInspectionLocFailure(
        error.response ? error.response.data : "An error occurred"
      )
    );
    throw error;
  }
};

// .................. Add Manufacturer Master .................

export const addManufacturerMaster = (descriptionData) => async (dispatch) => {
  dispatch(addManufacturerStart());
  try {
    const response = await axiosInstance.post(`${ADD_MANUFACTURER_MASTER}`, {
      name: descriptionData.name,
    });
    dispatch(addManufacturerSuccess(response.data));
    return response.data;
  } catch (error) {
    dispatch(
      addManufacturerFailure(
        error.response ? error.response.data : "An error occurred"
      )
    );
    throw error;
  }
};

// .................. Add Size Master .................

export const addSizeMaster = (descriptionData) => async (dispatch) => {
  dispatch(addSizeStart());
  try {
    const response = await axiosInstance.post(`${ADD_SIZE_MASTER}`, {
      name: descriptionData.name,
    });
    dispatch(addSizeSuccess(response.data));
    return response.data;
  } catch (error) {
    dispatch(
      addSizeFailure(error.response ? error.response.data : "An error occurred")
    );
    throw error;
  }
};

// .................. Add Surface Master .................

export const addSurfaceMaster = (descriptionData) => async (dispatch) => {
  dispatch(addSurfaceStart());
  try {
    const response = await axiosInstance.post(`${ADD_SURFACE_MASTER}`, {
      name: descriptionData.name,
    });
    dispatch(addSurfaceSuccess(response.data));
    return response.data;
  } catch (error) {
    dispatch(
      addSurfaceFailure(
        error.response ? error.response.data : "An error occurred"
      )
    );
    throw error;
  }
};

// .................. Add Type Master .................

export const addTypeMaster = (descriptionData) => async (dispatch) => {
  dispatch(addTypeStart());
  try {
    const response = await axiosInstance.post(`${ADD_TYPE_MASTER}`, {
      name: descriptionData.name,
    });
    dispatch(addTypeSuccess(response.data));
    return response.data;
  } catch (error) {
    dispatch(
      addTypeFailure(error.response ? error.response.data : "An error occurred")
    );
    throw error;
  }
};

// .................. Add Welder Master .................

export const addWelderMaster = (descriptionData) => async (dispatch) => {
  dispatch(addWelderStart());
  try {
    const response = await axiosInstance.post(`${ADD_WELDER_MASTER}`, {
      name: descriptionData.name,
    });
    dispatch(addWelderSuccess(response.data));
    return response.data;
  } catch (error) {
    dispatch(
      addWelderFailure(
        error.response ? error.response.data : "An error occurred"
      )
    );
    throw error;
  }
};

// ..................... Delete Description Master .....................

export const deleteDescriptionMaster = (masterId) => async (dispatch) => {
  dispatch(deleteDescriptionStart());
  try {
    const response = await axiosInstance.delete(
      `${ADD_DESCRIPTION_MASTER}/?master_id=${masterId}`
    );

    if (response.status !== 200) {
      throw new Error("Failed to delete description.");
    }

    dispatch(deleteDescriptionSuccess(response?.data?.result));
    return { success: true };
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error.message;
    dispatch(deleteDescriptionFailure(errorMessage));
     return { success: false, error: errorMessage };
  }
};

// ..................... Delete Ends Master .....................

export const deleteEndsMaster = (masterId) => async (dispatch) => {
  dispatch(deleteEndsStart());
  try {
    const response = await axiosInstance.delete(
      `${ADD_ENDS_MASTER}?master_id=${masterId}`
    );

    if (response.status !== 200) {
      throw new Error("Failed to delete end.");
    }

    dispatch(deleteEndsSuccess(response?.data?.result));
    return { success: true };
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error.message;
    dispatch(deleteEndsFailure(errorMessage));
    return { success: false, error: errorMessage };
  }
};

// ..................... Delete Inspection Loc Master .....................

export const deleteInspectionLocMaster = (masterId) => async (dispatch) => {
  dispatch(deleteInspectionLocStart());
  try {
    const response = await axiosInstance.delete(
      `${ADD_INSPECTION_LOC_MASTER}?master_id=${masterId}`
    );

    if (response.status !== 200) {
      throw new Error("Failed to delete end.");
    }

    dispatch(deleteInspectionLocSuccess(response?.data?.result));
    return { success: true };
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error.message;
    dispatch(deleteInspectionLocFailure(errorMessage));
     return { success: false, error: errorMessage };
  }
};

// ..................... Delete Manufacturer Master .....................

export const deleteManufacturerMaster = (masterId) => async (dispatch) => {
  dispatch(deleteManufacturerStart());
  try {
    const response = await axiosInstance.delete(
      `${ADD_MANUFACTURER_MASTER}?master_id=${masterId}`
    );

    if (response.status !== 200) {
      throw new Error("Failed to delete end.");
    }

    dispatch(deleteManufacturerSuccess(response?.data?.result));
    return { success: true };
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error.message;
    dispatch(deleteManufacturerFailure(errorMessage));
     return { success: false, error: errorMessage };
  }
};

// ..................... Delete Size Master .....................

export const deleteSizeMaster = (masterId) => async (dispatch) => {
  dispatch(deleteSizeStart());
  try {
    const response = await axiosInstance.delete(
      `${ADD_SIZE_MASTER}?master_id=${masterId}`
    );

    if (response.status !== 200) {
      throw new Error("Failed to delete end.");
    }
    dispatch(deleteSizeSuccess(response?.data?.result));
    return { success: true };
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error.message;
    dispatch(deleteSizeFailure(errorMessage));
     return { success: false, error: errorMessage };
  }
};

// ..................... Delete Surface Master .....................

export const deleteSurafceMaster = (masterId) => async (dispatch) => {
  dispatch(deleteSurfaceStart());
  try {
    const response = await axiosInstance.delete(
      `${ADD_SURFACE_MASTER}?master_id=${masterId}`
    );

    if (response.status !== 200) {
      throw new Error("Failed to delete end.");
    }

    dispatch(deleteSurfaceSuccess(response?.data?.result));
    return { success: true };
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error.message;
    dispatch(deleteSurfaceFailure(errorMessage));
     return { success: false, error: errorMessage };
  }
};

// ..................... Delete Type Master .....................

export const deleteTypeMaster = (masterId) => async (dispatch) => {
  dispatch(deleteTypeStart());
  try {
    const response = await axiosInstance.delete(
      `${ADD_TYPE_MASTER}?master_id=${masterId}`
    );
    if (response.status !== 200) {
      throw new Error("Failed to delete end.");
    }
    dispatch(deleteTypeSuccess(response?.data?.result));
    return { success: true };
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error.message;
    dispatch(deleteTypeFailure(errorMessage));
     return { success: false, error: errorMessage };
  }
};

// ..................... Delete Welder Master .....................

export const deleteWelderMaster = (masterId) => async (dispatch) => {
  dispatch(deleteWelderStart());
  try {
    const response = await axiosInstance.delete(
      `${ADD_WELDER_MASTER}?master_id=${masterId}`
    );
    if (response.status !== 200) {
      throw new Error("Failed to delete end.");
    }
    dispatch(deleteWelderSuccess(response?.data?.result));
    return { success: true };
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error.message;
    dispatch(deleteWelderFailure(errorMessage));
     return { success: false, error: errorMessage };
  }
};

// .................. Edit Description Master ....................

export const editDescriptionMaster = (formData) => async (dispatch) => {
  dispatch(editDescriptionStart());
  try {
    const response = await axiosInstance.put(
      `${ADD_DESCRIPTION_MASTER}`,
      formData
    );
    if (response.status !== 200) {
      throw new Error("Failed to update project.");
    }
    console.log("response?.data?.result", response?.data?.result);
    dispatch(editDescriptionSuccess(response?.data?.result));
  } catch (error) {
    dispatch(editDescriptionFailure(error.message));
  }
};

// .................. Edit Ends Master ....................

export const editEndsMaster = (formData) => async (dispatch) => {
  dispatch(editDescriptionStart());
  try {
    const response = await axiosInstance.put(`${ADD_ENDS_MASTER}`, formData);
    if (response.status !== 200) {
      throw new Error("Failed to update project.");
    }
    console.log("response?.data?.result", response?.data?.result);
    dispatch(editDescriptionSuccess(response?.data?.result));
  } catch (error) {
    dispatch(editDescriptionFailure(error.message));
  }
};

// .................. Edit InspectionLoc Master ....................

export const editInspectionLocMaster = (formData) => async (dispatch) => {
  dispatch(editDescriptionStart());
  try {
    const response = await axiosInstance.put(
      `${ADD_INSPECTION_LOC_MASTER}`,
      formData
    );
    if (response.status !== 200) {
      throw new Error("Failed to update project.");
    }
    dispatch(editDescriptionSuccess(response?.data?.result));
  } catch (error) {
    dispatch(editDescriptionFailure(error.message));
  }
};

// .................. Edit Manufacturer Master ....................

export const editManufacturerMaster = (formData) => async (dispatch) => {
  dispatch(editDescriptionStart());
  try {
    const response = await axiosInstance.put(
      `${ADD_MANUFACTURER_MASTER}`,
      formData
    );
    if (response.status !== 200) {
      throw new Error("Failed to update project.");
    }
    dispatch(editDescriptionSuccess(response?.data?.result));
  } catch (error) {
    dispatch(editDescriptionFailure(error.message));
  }
};

// .................. Edit Size Master ....................

export const editSizeMaster = (formData) => async (dispatch) => {
  dispatch(editDescriptionStart());
  try {
    const response = await axiosInstance.put(`${ADD_SIZE_MASTER}`, formData);
    if (response.status !== 200) {
      throw new Error("Failed to update project.");
    }
    dispatch(editDescriptionSuccess(response?.data?.result));
  } catch (error) {
    dispatch(editDescriptionFailure(error.message));
  }
};

// .................. Edit Surface Master ....................

export const editSufaceMaster = (formData) => async (dispatch) => {
  dispatch(editDescriptionStart());
  try {
    const response = await axiosInstance.put(`${ADD_SURFACE_MASTER}`, formData);
    if (response.status !== 200) {
      throw new Error("Failed to update project.");
    }
    dispatch(editDescriptionSuccess(response?.data?.result));
  } catch (error) {
    dispatch(editDescriptionFailure(error.message));
  }
};

// .................. Edit Type Master ....................

export const editTypeMaster = (formData) => async (dispatch) => {
  dispatch(editDescriptionStart());
  try {
    const response = await axiosInstance.put(`${ADD_TYPE_MASTER}`, formData);
    if (response.status !== 200) {
      throw new Error("Failed to update project.");
    }
    dispatch(editDescriptionSuccess(response?.data?.result));
  } catch (error) {
    dispatch(editDescriptionFailure(error.message));
  }
};

// .................. Edit Welder Master ....................

export const editWelderMaster = (formData) => async (dispatch) => {
  dispatch(editDescriptionStart());
  try {
    const response = await axiosInstance.put(`${ADD_WELDER_MASTER}`, formData);
    if (response.status !== 200) {
      throw new Error("Failed to update project.");
    }
    dispatch(editDescriptionSuccess(response?.data?.result));
  } catch (error) {
    dispatch(editDescriptionFailure(error.message));
  }
};
